import React from 'react'
import { HOME_PARTNERS_API } from '../../../Utilities/APIs'
import IPCRUD from '../../Partials/Layouts/CRUDs/CRUDLayouts/IPCRUD/IPCRUD'

function HomePartners() {
  return (
    <IPCRUD
        // common props
        api={HOME_PARTNERS_API}
        screenTopicSingular={'Home Partner'}
        screenTopicPlural={'Home Partners'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // field props
        maxPrecedence={8}
    />
  )
}

export default HomePartners